module.exports = __webpack_public_path__ + "img/ArchiveManagerNetwork.0b49f0b1.svg";